import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/main.css';
import prawnImg from '../assets/prawn.jpg';
import vegImg from '../assets/veg.jpg';
import muttonImg from '../assets/mutton.jpg';
import chickenImg from '../assets/chicken.jpg';

const menuItems = [
  {
    name: 'Prawn Biryani',
    description: 'Royal prawns cooked with fragrant basmati rice.',
    image: prawnImg,
    price: 399,
  },
  {
    name: 'Veg Biryani',
    description: 'Flavor-packed biryani made with fresh vegetables.',
    image: vegImg,
    price: 249,
  },
  {
    name: 'Mutton Biryani',
    description: 'Slow-cooked mutton layered with aromatic rice.',
    image: muttonImg,
    price: 449,
  },
  {
    name: 'Chicken Dum Biryani',
    description: 'Authentic dum biryani with juicy chicken.',
    image: chickenImg,
    price: 299,
  },
];

const Menu = () => {
  const [selectedQty, setSelectedQty] = useState({});
  const navigate = useNavigate();

  const handleQtyChange = (index, qty) => {
    setSelectedQty({ ...selectedQty, [index]: qty });
  };

  const handleOrder = (item, index) => {
    const qty = selectedQty[index] || 1;
    navigate('/checkout', { state: { item, qty } });
  };

  return (
    <div className="royal-background" style={{ padding: '2rem' }}>
      <h2 style={{ color: '#ffd700', textAlign: 'center', marginBottom: '2rem' }}>Our Royal Menu</h2>
      <div className="menu-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '2rem'
      }}>
        {menuItems.map((item, index) => {
          const qty = selectedQty[index] || 1;
          const totalPrice = qty * item.price;

          return (
            <div key={index} className="menu-card" style={{
              backgroundColor: '#001d4a',
              color: '#fff',
              padding: '1.5rem',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.5)',
              textAlign: 'center'
            }}>
              <img src={item.image} alt={item.name} style={{
                width: '100%',
                height: '200px',
                objectFit: 'cover',
                borderRadius: '10px'
              }} />
              <h3 style={{ color: '#ffd700', marginTop: '1rem' }}>{item.name}</h3>
              <p style={{ fontSize: '0.95rem', margin: '0.5rem 0' }}>{item.description}</p>
              <p style={{ fontWeight: 'bold', fontSize: '1rem' }}>₹{item.price} × {qty} = ₹{totalPrice}</p>
              <div style={{ marginTop: '1rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Quantity:</label>
                <select
                  value={qty}
                  onChange={(e) => handleQtyChange(index, parseInt(e.target.value))}
                  style={{ padding: '0.3rem', borderRadius: '6px' }}
                >
                  {[1, 2, 3, 4].map(q => (
                    <option key={q} value={q}>{q}</option>
                  ))}
                </select>
              </div>
              <div className="button-container" style={{ marginTop: '1rem' }}>
                <button className="primary-btn" onClick={() => handleOrder(item, index)}>Order Now</button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Menu;
